import { Button, Card } from "antd";
import "../styles/index.css";
import { TelenganaApiService } from "../httpsservice/ApiService";
import { useLoaderData, useParams } from "react-router-dom";
import { formatDate } from "../utils";

const StatusPageTG = () => {
  const { txn_id } = useParams();
  const txndata = useLoaderData();

  const handelDownload = async () => {
    try {
      const queryData = { txn_id: txn_id };
      const response = await TelenganaApiService.downloadInvoice(queryData, {
        responseType: "blob",
      });

      const fileType = "application/pdf";
      if (fileType !== "application/pdf") {
        console.error("⚠️ Invalid response type received:", fileType);
        return;
      }
      const blob = new Blob([response], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "invoice.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("❌ Error downloading file:", error);
    }
  };

  return (
    <>
      <div className="main-wrapper-telangana">
        <div className="center-container">
          <div className="center-box-bill">
            <Card
              className="service-number-card"
              cover={
                <div className="payment-status">
                  <div className="tel-logo-main">
                    <img
                        alt="BSES"
                        className="tgspdcl-logo"
                        src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/tgspdcl-logo.jpg"
                      />
                    <span className="elecricity-title">SOUTHERN POWER DISTRIBUTION COMPANY OF TELANGANA LIMITED</span>
                    {/* <img
                      alt="Bank Logo"
                      className="bob-logo"
                      src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/Federal_bank.svg"
                    /> */}
                  </div>
                  {txndata?.STATUS === "SUCCESS" ? (
                    <div className="payment-status-logo-name">
                      <img
                        alt="Success"
                        className="status-icon"
                        src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/Success.svg"
                      />
                      <p className="payment-success-text-tg">Payment Successful!</p>
                    </div>
                  ) : (
                    <div className="payment-status-logo-name">
                      <img
                        alt="Failed"
                        className="status-icon"
                        src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/failed_icon.svg"
                      />
                      <p className="payment-failure-text-tg">Payment Failed!</p>
                    </div>
                  )}
                </div>
              }
            >
              {(
                <table className="status-table">
                  <tbody>
                    <tr>
                      <td>Unique Service Number</td>
                      <td>{txndata?.Unique_Service_Number || "NA"}</td>
                    </tr>
                    <tr>
                      <td>Service Number</td>
                      <td>{txndata?.Service_Number || "NA"}</td>
                    </tr>
                    <tr>
                      <td>Name</td>
                      <td>{txndata?.Name || "NA"}</td>
                    </tr>
                    <tr>
                      <td>ERO</td>
                      <td>{txndata?.ERO || "NA"}</td>
                    </tr>
                    <tr>
                      <td>Bill Date</td>
                      <td>{formatDate(txndata?.Bill_Date) || "NA"}</td>
                    </tr>
                    <tr>
                      <td>Due Date</td>
                      <td>{formatDate(txndata?.Due_Date) || "NA"}</td>
                    </tr>
                    <tr>
                      <td>Bill Amount</td>
                      <td>
                      ₹{" "}
                        {txndata?.Bill_Amount
                          ? parseFloat(txndata.Bill_Amount).toFixed(2)
                          : "0.00"}
                      </td>
                    </tr>
                    <tr>
                      <td>ACD Amount</td>
                      <td>
                      ₹{" "}
                        {txndata?.ACD_Amount
                          ? parseFloat(txndata.ACD_Amount).toFixed(2)
                          : "0.00"}
                      </td>
                    </tr>
                    <tr>
                      <td>Amount</td>
                      <td>
                      ₹{" "}
                        {txndata?.Amount
                          ? parseFloat(txndata.Amount).toFixed(2)
                          : "0.00"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
              {(
                <>
                  {txndata?.STATUS === "SUCCESS" ? (
                    <div className="receipt-buttons-tg">
                      <Button
                        className="make-another-payment-tg"
                        size="large"
                        block
                        onClick={() => {
                          window.location.href = "/TGSPDCL/Billpay";
                        }}
                      >
                        Make Another Payment
                      </Button>
                      <Button
                        className="download-receipt-tg"
                        size="large"
                        block
                        onClick={handelDownload}
                      >
                        Download Receipt
                      </Button>
                    </div>
                  ) : (
                    <div className="receipt-buttons-tg">
                    <Button
                      className="retry-payment-tg"
                      size="large"
                      block
                      onClick={() => {
                        window.location.href = "/TGSPDCL/Billpay";
                      }}
                    >
                      Retry Payment
                    </Button>

                    <Button
                        className="download-receipt-tg"
                        size="large"
                        block
                        onClick={handelDownload}
                      >
                        Download Receipt
                      </Button>

                    </div>
                    
                  )}
                </>
              )}
            </Card>
            <div className="poweredby-logo-main">
              <img
                alt="poweredby-logo"
                className="poweredby-logo"
                src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/poweredbyeasebuzz.png"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatusPageTG;
